export const getStyleFromTextPreset = (
  wixParam: any,
  additionals: any = {},
) => ({
  // additional can be minHeight, textDecoration, color
  fontFamily: wixParam.fontFamily,
  fontSize: wixParam.size,
  lineHeight: wixParam.lineHeight,
  fontStyle: wixParam.style,
  fontWeight: wixParam.weight,
  ...additionals,
});
